class DipnTheme {
  constructor() {
    this.overlay = document.querySelector('[data-overlay]');
    this.menu = document.querySelector('[data-menu-drawer]');
    this.cart = document.querySelector('[data-cart-drawer]');
    this.search = document.querySelector('[data-search-modal]');
    this.filters = document.querySelector('[data-drawer="filters"]');
    this.header = document.querySelector('[data-site-header]');
    this.menuScrim = document.querySelector('[data-menu-scrim]');
    this.navItems = [...document.querySelectorAll('[data-nav-item]')];
    this.bind();
  }

  bind() {
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-action]');
      if (trigger) {
        const action = trigger.dataset.action;
        if (action === 'open-menu') this.open(this.menu);
        if (action === 'open-cart') this.open(this.cart);
        if (action === 'open-search') this.open(this.search);
        if (action === 'close-all') this.closeAll();
      }

      const drawerTrigger = event.target.closest('[data-drawer-open]');
      if (drawerTrigger?.dataset.drawerOpen === 'filters') this.open(this.filters);
      if (event.target.closest('[data-drawer-close]')) this.closeAll();

      const submenuToggle = event.target.closest('[data-submenu-toggle]');
      if (submenuToggle) {
        event.preventDefault();
        const item = submenuToggle.closest('[data-nav-item]');
        if (item?.classList.contains('is-open')) this.closeNavItem(item);
        else this.openNavItem(item);
        return;
      }

      if (!event.target.closest('[data-nav-item]') && !event.target.closest('[data-menu-scrim]')) this.closeNavMenus();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll();
    });

    this.menuScrim?.addEventListener('click', () => this.closeNavMenus());
    this.navItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 1181px)').matches && item.querySelector('[data-nav-dropdown]')) this.openNavItem(item);
      });
      item.addEventListener('mouseleave', () => {
        if (window.matchMedia('(min-width: 1181px)').matches) this.closeNavItem(item);
      });
      item.addEventListener('focusin', () => {
        if (item.querySelector('[data-nav-dropdown]')) this.openNavItem(item);
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) this.closeNavItem(item);
      });
    });

    if (this.header?.dataset.sticky === 'true') {
      this.updateHeader();
      window.addEventListener('scroll', () => this.updateHeader(), { passive: true });
    }
    window.addEventListener('resize', () => {
      this.updateScrimPosition();
      if (window.matchMedia('(max-width: 1180px)').matches) this.closeNavMenus();
    });

    document.addEventListener('submit', (event) => {
      if (event.target.matches('.js-quick-add')) this.quickAdd(event);
    });

    document.querySelectorAll('[data-product-root]').forEach((root) => this.bindProduct(root));
    document.querySelectorAll('[data-quantity], [data-quantity-picker]').forEach((root) => this.bindQuantity(root));
    document.querySelectorAll('[data-sort-by], [data-collection-sort]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.assign(url.toString());
      });
    });
    this.loadRecommendations();
  }

  open(panel) {
    this.closeAll();
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    this.overlay?.classList.add('is-open');
    document.body.classList.add('is-locked');
  }

  closeAll() {
    [this.menu, this.cart, this.search, this.filters].forEach((panel) => {
      panel?.classList.remove('is-open');
      panel?.setAttribute('aria-hidden', 'true');
    });
    this.overlay?.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    this.closeNavMenus();
  }

  openNavItem(item) {
    if (!item) return;
    this.navItems.forEach((entry) => {
      if (entry !== item) this.closeNavItem(entry, false);
    });
    item.classList.add('is-open');
    item.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'true');
    this.updateScrimPosition();
    this.menuScrim?.classList.add('is-open');
  }

  closeNavItem(item, hideScrim = true) {
    if (!item) return;
    item.classList.remove('is-open');
    item.querySelector('[data-submenu-toggle]')?.setAttribute('aria-expanded', 'false');
    if (hideScrim && !this.navItems.some((entry) => entry.classList.contains('is-open'))) this.menuScrim?.classList.remove('is-open');
  }

  closeNavMenus() {
    this.navItems.forEach((item) => this.closeNavItem(item, false));
    this.menuScrim?.classList.remove('is-open');
  }

  updateScrimPosition() {
    if (!this.header) return;
    document.documentElement.style.setProperty('--menu-scrim-top', `${Math.max(0, this.header.getBoundingClientRect().bottom)}px`);
  }

  updateHeader() {
    if (!this.header) return;
    const shouldCompact = window.scrollY > 120 && window.matchMedia('(min-width: 1181px)').matches;
    this.header.classList.toggle('is-compact', shouldCompact);
    if (this.navItems.some((item) => item.classList.contains('is-open'))) this.updateScrimPosition();
  }

  async quickAdd(event) {
    event.preventDefault();
    const form = event.target;
    const button = form.querySelector('button');
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add item');
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json());
      document.querySelectorAll('[data-cart-count]').forEach((count) => count.textContent = cart.item_count);
      const notice = document.querySelector('[data-cart-notice]');
      if (notice) notice.hidden = false;
      this.open(this.cart);
    } catch (error) {
      button.textContent = 'Try again';
      setTimeout(() => button.textContent = original, 1600);
      return;
    }
    button.disabled = false;
    button.textContent = original;
  }

  bindQuantity(root) {
    const input = root.querySelector('input');
    root.querySelector('[data-minus], [data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value) - 1);
    });
    root.querySelector('[data-plus], [data-quantity-plus]')?.addEventListener('click', () => input.value = Number(input.value) + 1);
  }

  bindProduct(root) {
    const variantsScript = root.querySelector('[data-product-json], [data-product-variants]');
    const form = root.querySelector('[data-product-form], .product-form');
    if (!variantsScript || !form) return;
    const variants = JSON.parse(variantsScript.textContent);
    const idInput = form.querySelector('[name="id"]');
    const addButton = form.querySelector('[name="add"]');
    const price = root.querySelector('[data-product-price]');
    const addLabel = form.querySelector('[data-add-label]');

    root.querySelectorAll('[data-option-index]').forEach((select) => {
      select.addEventListener('change', () => {
        const options = [...root.querySelectorAll('[data-option-index]')].map((element) => element.value);
        const variant = variants.find((entry) => entry.options.every((option, index) => option === options[index]));
        if (!variant) {
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = 'Unavailable';
          return;
        }
        idInput.value = variant.id;
        addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Add to bag' : 'Sold out';
        if (price) price.textContent = this.formatMoney(variant.price);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    });

    root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        root.querySelectorAll('[data-gallery-thumb]').forEach((entry) => entry.classList.remove('is-active'));
        root.querySelectorAll('[data-gallery-media]').forEach((entry) => entry.classList.remove('is-active'));
        thumb.classList.add('is-active');
        root.querySelector(`[data-gallery-media="${thumb.dataset.galleryThumb}"]`)?.classList.add('is-active');
      });
    });

    const thumbnailRail = root.querySelector('.product-gallery__thumbs');
    root.querySelectorAll('[data-gallery-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!thumbnailRail) return;
        const direction = button.dataset.galleryScroll === 'up' ? -1 : 1;
        thumbnailRail.scrollBy({ top: direction * 180, behavior: 'smooth' });
      });
    });
  }

  async loadRecommendations() {
    const root = document.querySelector('[data-product-recommendations]');
    if (!root || !root.dataset.url) return;
    try {
      const html = await fetch(root.dataset.url).then((response) => response.text());
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const replacement = documentFragment.querySelector('[data-product-recommendations]');
      if (replacement?.innerHTML.trim()) root.innerHTML = replacement.innerHTML;
    } catch (_) {
      /* Recommendations are optional; leave the section empty if unavailable. */
    }
  }

  formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: window.Shopify?.currency?.active || 'EGP'
      }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2)} ${window.Shopify?.currency?.active || 'EGP'}`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => new DipnTheme());
